/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CrosshairRegion32 = (props: SVGProps) => (
    <AccessibleSVG viewBox="0 0 32 32" width={32} height={32} {...props}>
        <g fillRule="nonzero" fill="none">
            <path fill="#fff" d="M23 15h-6.01V9h-2.98v6H8v3h6.01v6h2.98v-6H23z" />
            <path fill="#231F1F" d="M21.99 16.01h-6V10h-.98v6.01h-6v.98h6V23h.98v-6.01h6z" />
            <path d="M27 5h-8v8h8V5zm-3 3v2h-2V8h2z" fill="#fff" />
            <path d="M26 6h-6v6h6V6zm-1 1v4h-4V7h4z" fill="#231F1F" />
        </g>
    </AccessibleSVG>
);

export default CrosshairRegion32;
